module.exports = __webpack_public_path__ + "static/media/logo.11f3464e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/logo.png
// module id = 237
// module chunks = 0